
export class CatlistForm {
  public limit: number;
  public offset: number;
  public count: number;
  public vendorId: number;
  constructor(catlistForm: any) {
    this.limit = catlistForm.limit || '';
    this.offset = catlistForm.offset || '';
    this.count = catlistForm.count || '';
    this.vendorId = catlistForm.vendorId || '';
  }
}
